




import Vue from 'vue';
import OfficialDocumentDelete from '@/components/official-documents/official-document-delete.component.vue';

export default Vue.extend({
  components: {
    'official-document-delete': OfficialDocumentDelete,
  },
});
